import { render } from "./ListUsers.vue?vue&type=template&id=b4aa11ea"
import script from "./ListUsers.vue?vue&type=script&lang=js"
export * from "./ListUsers.vue?vue&type=script&lang=js"
script.render = render

export default script